// src/components/calendar/EventItem.jsx
import React, { useCallback } from 'react';
import { Paper, Typography } from '@mui/material';

// Memoizamos el componente para mejorar el rendimiento
const EventItem = React.memo(({ event, onDragStart, onEventClick }) => {
    const handleDragStart = useCallback((e) => {
        onDragStart(e, event); // Llama a la función onDragStart con el evento
    }, [onDragStart, event]);

    const handleClick = useCallback(() => {
        console.log('Clic en evento:', event); // Consola para depuración
        onEventClick(event); // Llama a la función onEventClick con el evento
    }, [onEventClick, event]);

    return (
        <Paper
            elevation={2}
            sx={{ p: 1, mb: 1, cursor: 'grab', backgroundColor: '#1976d2', color: '#fff' }}
            draggable
            onDragStart={handleDragStart}
            onClick={handleClick}
        >
            <Typography variant="body2">{event.type}</Typography>
        </Paper>
    );
});

export default EventItem;
